import { Country } from '../../enums/country';

export const EU_COUNTRIES = [
  Country.AT,
  Country.BE,
  Country.BG,
  Country.HR,
  Country.CY,
  Country.CZ,
  Country.DK,
  Country.EE,
  Country.FI,
  Country.FR,
  Country.GR,
  Country.ES,
  Country.NL,
  Country.IE,
  Country.LT,
  Country.LU,
  Country.LV,
  Country.MT,
  Country.DE,
  Country.PL,
  Country.PT,
  Country.RO,
  Country.SK,
  Country.SI,
  Country.SE,
  Country.HU,
  Country.IT,
] as const;

export const EUROPE_COUNTRIES = [
  ...EU_COUNTRIES,
  Country.AL,
  Country.AD,
  Country.AZ,
  Country.BY,
  Country.BA,
  Country.ME,
  Country.GE,
  Country.GG,
  Country.IS,
  Country.JE,
  Country.LI,
  Country.MK,
  Country.MD,
  Country.MC,
  Country.NO,
  Country.RU,
  Country.SM,
  Country.RS,
  Country.CH,
  Country.TR,
  Country.UA,
  Country.GB,
  Country.IM,
] as const;
